import { JxsComponent } from '@jxs/component'

if (!customElements.get('jxs-product-grid')) {
  class JxsProductGrid extends JxsComponent {

    #swiper = null;

    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();
      this.initSwiper();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.#swiper.destroy(true, true);
    }

    initSwiper() {
      this.#swiper = new Swiper(this.refs.swiper, {
        snapToSlideEdge: false,
        navigation: {
          nextEl: '.carousel-arrow[next]',
          prevEl: '.carousel-arrow[prev]',
        },
        spaceBetween: 16,
        slidesPerView: this.getDataset('columnsMobile', 1.5),
        enabled: this.getDataset('enableMobile'),
        breakpoints: {
          768: {
            slidesPerView: this.getDataset('columnsTablet', 3),
            enabled: this.getDataset('enableDesktop')
          },
          1024: {
            slidesPerView: this.getDataset('columnsDesktop', 4),
            enabled: this.getDataset('enableDesktop')
          }
        }
      });
    }
  }

  customElements.define('jxs-product-grid', JxsProductGrid);
}